import React, { useContext } from 'react';
import { VIEW, EDIT, COPY, DELETE, UNLOCK, REPORTS } from '../../assets/Constants/actionsTypes';
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
import { DropDownButton, DropDownButtonItem } from '@progress/kendo-react-buttons';
import { useTranslation } from 'react-i18next';
import './model.css'
import AuthContext from '../../context/Auth/AuthContext';

//* Icons
import { TiMediaStopOutline, TiInputChecked } from "react-icons/ti";

const ModelGrid = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');
    // Session context to get the current institution data
    const { user } = useContext(AuthContext);

    // Used to show the icon inside the grid
    const showCheckIcon = (props) => {
        return (
            <td className="readyAssessment_check" style={{ textAlign: "center" }}>
                {
                    props.dataItem.isReadyForAssessment ? <TiInputChecked /> : <TiMediaStopOutline />
                }
            </td>
        );
    }

    // * If the model is being edited by the logged in user, an action called UNLOCK will appear. 
    // * This action releases the model so that another user can edit it. 
    const showUnlockAction = (props) => {
        if (props.dataItem.editLockUserCode !== null && props.dataItem.editLockUserCode === user.email) {
            return (
                <DropDownButtonItem text={t('grids.unlock_btn')} value={UNLOCK} />
            );
        }
    }

    return (
        <>
            <Grid style={{ height: 'calc(70vh)' }} data={[...props.data]}>
                {/* this is the message when there are no records */}
                <GridNoRecords>{t('grids.no_records')}</GridNoRecords>
                {/* columns of the grid */}
                <Column field="code" title={t('model.grid_column_code')} />
                <Column field="name" title={t('model.grid_column_name')} />
                <Column
                    field="isReadyForAssessment"
                    title={t('model.grid_column_ready_assessment')}
                    cell={showCheckIcon}
                    className="header_align"
                    width="200"
                />
                {/* action column */}
                <Column
                    title={t('grids.action_col')}
                    width="100px"
                    field="actions"
                    cell={gridProps => (
                        <td className="text-center p-0">
                            <DropDownButton className="grid-drop-btn" text="..." onItemClick={(e) => { props.onActionClick(e.item, gridProps.dataItem); }}>
                                <DropDownButtonItem text={t('grids.view_btn')} value={VIEW} />
                                <DropDownButtonItem text={t('grids.edit_btn')} value={EDIT} />
                                {showUnlockAction(gridProps)}
                                <DropDownButtonItem text={t('grids.copy_btn')} value={COPY} />
                                <DropDownButtonItem text={t('grids.reports_btn')} value={REPORTS} />
                                <DropDownButtonItem text={t('grids.delete_btn')} value={DELETE} />
                            </DropDownButton>
                        </td>
                    )}
                />
            </Grid>
        </>
    )
}

export default ModelGrid